import React from "react";

import "./BulkFileItem.scss";
import { Dropdown } from "react-bootstrap";

import filePDF from "../../../assets/icons/file-pdf-24.svg";
import binIcon from "../../../assets/icons/bin.svg";
import ThreeDot from "../../../assets/icons/three_dots.svg";
import replaceIcon from "../../../assets/icons/replace.svg";

const threeDotMenu = React.forwardRef(({ onClick }, ref) => (
  <button
    className="dropdown custom-dropdown ic-ghost"
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    <img className="dropdown-toggle" src={ThreeDot} alt="Three dots" />
  </button>
));

const bulkFileItem = ({
  showReplaceButton = false,
  handleReplacePrimaryFile,
  showDeleteDownloadDropdown = false, 
  showDeleteButton = true, 
  isPrimaryFile = true, 
  ...props}) => {
    
  const handleDelete = () => {
    props.handleDelete(props.keyId);
  };
  const handleDownload = () => {
    props.handleDownload(false, props.keyId);
  };
  
  return (
    <div
      className={[
        "pl-6 pr-2 mt-3 uploaded-file d-flex align-items-center",
        props.isActive ? "active-doc" : "",
      ].join(" ")}
    >
      {/* LEFT */}
      <div className="d-flex">
        <div
          className="uploaded-file-icon"
          onClick={() => props.handleOnClick(props.keyId, isPrimaryFile)}
        >
          <img src={filePDF} alt="pdf" />
        </div>
        <div
          className="ml-2 uploaded-file-title overflow-hidden"
          onClick={() => props.handleOnClick(props.keyId, isPrimaryFile)}
        >
          {props.file}
        </div>
      </div>


      {/* RIGHT */}
      { 
        showDeleteDownloadDropdown ? (
          <div className="d-flex upload-file-right" >
            <Dropdown>
              <Dropdown.Toggle as={threeDotMenu}></Dropdown.Toggle>
              <Dropdown.Menu>
                
                  <Dropdown.Item
                    as="a"
                    onClick={handleDownload}
                  >
                    Download
                  </Dropdown.Item>
                  <Dropdown.Item
                    as="a"
                    onClick={handleDelete}
                  >
                    Delete
                  </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        ) :
        showDeleteButton ? (
          <div className="d-flex upload-file-right" >
            <div className="uploaded-file-progress-bar"></div>
            <div className="uploaded-file-cancel" onClick={handleDelete}>
              <img src={binIcon} alt="x" className="img-fluid" />
            </div>
          </div>
        ) :
        showReplaceButton ? (
          <div className="d-flex upload-file-right" >
            <div className="uploaded-file-replace-bar"></div>
            <div className="uploaded-file-replace" onClick={handleReplacePrimaryFile}>
              <img src={replaceIcon} alt="r" className="img-fluid" />
            </div>
          </div>
        ) : null
      }
      
    </div>
  );
};

export default bulkFileItem;
